import Button from "antd/lib/button";
import Modal from "antd/lib/modal"
import Typography from "antd/lib/typography";
import React, { forwardRef, useImperativeHandle } from "react"
import Lottie from "lottie-react";
import animationGift from "../../assets/animations/animation_gift.json";
import { IEventOrderInfoModel } from "../../models/eventModel";
const { Title } = Typography;

const PopupResult = (props: IProps, ref: React.Ref<IPopupResultRef>) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [order, setOrder] = React.useState<IEventOrderInfoModel | null>(null)
  const [gift, setGift] = React.useState<string>("")



  useImperativeHandle(ref, () => {
    return {
      openPopup: openPopup
    };
  });

  const openPopup = (order: IEventOrderInfoModel, gift: string) => {
    setOrder(order);
    setGift(gift)
    showModal()
  }

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const renderFooter = () => {
    return null;
  }

  const render = () => {
    return <div className="rs-body-wrapper">
      <div className="icon-wrapper">
        <Lottie animationData={animationGift} loop={true} style={{
          width: "180px",
          display: "flex",
          justifyContent: "center"
        }} />
      </div>
      <Title className="rs-msg" level={5}>Chúc mừng khách hàng <b>{order?.customerName}</b><br /> đã trúng <br /><b>{gift}</b></Title>
      <div>
        <Button type="primary" onClick={() => handleCancel()}>Đóng</Button>
      </div>
    </div>
  }

  return <div>
    <Modal title={() => <></>}
      className="lucky-wheel-result"
      centered
      visible={isModalOpen}
      onOk={handleOk}
      closable={false}
      onCancel={handleCancel}
      footer={renderFooter()}>
      {render()}
    </Modal>
  </div>
}


export default forwardRef(PopupResult)

interface IProps {

}

export interface IPopupResultRef {
  openPopup: (order: IEventOrderInfoModel, gift: string) => void
}